module.exports = __webpack_public_path__ + "img/bg.27ef2221.png";